import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainSyncConfigGroup(id) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/sync_t4/${id}`,
    method: "post",
  });
}
